import { EventsName } from '@space-lib-events/constants'

const EVENT_NAME = EventsName.REMOVE_USER_NO_ACCESS_ROLE

export const removeUserNoAccessRoleEventDispatch = () => {
  const removeRoleEvent = new CustomEvent(EVENT_NAME)

  window.dispatchEvent(removeRoleEvent)
}

export const removeUserNoAccessRoleEventListener = (listener: () => void) => {
  window.addEventListener(EVENT_NAME, listener)

  return () => {
    window.removeEventListener(EVENT_NAME, listener)
  }
}
